import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from "@/lib/utils"

const Tabs = TabsPrimitive.Root

const TabsList = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      // v2.71.19 — Mobile-friendly horizontal scroll for overflowing tabs.
      // • `flex` (was inline-flex) + `max-w-full` lets the list claim full
      //   container width on mobile so overflow-x-auto can engage.
      // • `overflow-x-auto` + `tabs-list-scroll` (defined in index.css) gives
      //   smooth horizontal swipe with hidden scrollbar + iOS momentum +
      //   scroll-chaining containment (no vertical-scroll conflict).
      // • `flex-nowrap` prevents triggers from wrapping to a second row.
      // • Removed `justify-center` so the leftmost triggers stay visible when
      //   the list overflows; on desktop TabsList is sized-to-content via the
      //   underlying Radix primitive so no horizontal layout change.
      "flex max-w-full h-9 items-center flex-nowrap rounded-lg bg-muted p-1 text-muted-foreground overflow-x-auto tabs-list-scroll",
      className
    )}
    {...props} />
))
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow",
      className
    )}
    {...props} />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className
    )}
    {...props} />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsList, TabsTrigger, TabsContent }
